import React from 'react'

export default function footer() {
    return (
        <div>
            
        </div>
    )
}
